export default __webpack_public_path__ + "static/media/wc.6de05dab.svg";